






































import { Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

@Component({
  components: {}
})
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  mainEquipId = 0;

  dispatchType = "equipment/salecounter";

  columns: any[] = [
    { title: "ID", dataIndex: "id" },
    { title: "名称", dataIndex: "name" },
    { title: "门编号", dataIndex: "number" },
    { title: "添加时间", dataIndex: "created_time" },
    { title: "更新时间", dataIndex: "updated_time" },
    { title: "打开时间", dataIndex: "open_time" },
    { title: "关闭时间", dataIndex: "close_time" },
    { title: "状态", scopedSlots: { customRender: "status" } }
  ];

  mounted() {
    this.loadData(
      {
        stadium_id: this.stadiumId
      },
      false
    );
  }
}
